import { useAuthStore } from '../stores/authStore';
import { UserRoles } from '../types';

export function useDemoMode(): { isDemo: boolean } {
  const user = useAuthStore((state) => state.user);
  const isDemo = user?.organization_is_demo === true || user?.role === UserRoles.Demo;
  return { isDemo };
}
